import request from '@/utils/request'
// import eventDetail from './mockData/eventDetail.json'

/* const mockData = (data) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data)
    }, 500)
  })
} */

export function isLoginApi () {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + '/cityline_check_tk.do',
    method: 'GET'
  })
}

export function getEventDetailApi (eventId) {
  return request({
    url: process.env.VUE_APP_MELCO_DATA_BASE_URL + `/json/${eventId}.json?v=${Date.now()}`,
    method: 'GET'
  })
}

export function getEventSeatApi (eventId, data) {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + `/events/${eventId}/seating-plan/base/`,
    method: 'POST',
    data
  })
}

export function getAreaApi (eventId, data) {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + `/events/${eventId}/seating-plan/area/`,
    method: 'POST',
    data
  })
}

export function reserveResultApi (eventId, data) {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + `/events/${eventId}/reserve/`,
    method: 'POST',
    data
  })
}

export function cancelResultApi (eventId, data, loading = true) {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + `/events/${eventId}/cancel/`,
    method: 'POST',
    data,
    headers: {
      loading,
      isHideError: true
    }
  })
}

export function getReserveResultApi (eventId) {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + `/events/${eventId}/reserve/`,
    method: 'GET'
  })
}

// 提交信息
export function checkoutShoppingBasketApi (data) {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + '/shoppingBasket/checkout',
    method: 'POST',
    data
  })
}

export function melcoPaymentApi (data) {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + '/payment',
    method: 'POST',
    data
  })
}

export function getOrderStatusApi (data) {
  return request({
    url: process.env.VUE_APP_MELCO_API_BASE_URL + '/orders/status/',
    method: 'POST',
    data
  })
}

// 获取区号
export function getCountryCodeListApi () {
  return request({
    url: process.env.VUE_APP_MELCO_DATA_BASE_URL + '/country-code.json',
    method: 'GET'
  })
}
